import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Clock, Send, Instagram, Facebook, Linkedin } from 'lucide-react';
import axios from 'axios';
import Swal from 'sweetalert2';
import './ContactPage.css';
import SEO from '../SEO';
const API_URL = 'https://api.sohanihandicrafts.com:5010';
const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '', email: '', phone: '', message: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API_URL}/api/contact/send`, formData);
      Swal.fire({
        icon: 'success',
        title: 'Message Sent!',
        text: 'Our team will contact you shortly.',
        timer: 3000,
        showConfirmButton: false
      });
      setFormData({ name: '', email: '', phone: '', message: '' }); // Reset
    } catch (err) {
      Swal.fire('Error', 'Failed to send message', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <SEO 
  title="Contact for Wholesale & Export Inquiries | Jodhpur Office"
  description="Looking for a reliable handicraft partner? Contact Sohani Handicrafts for wholesale prices, bulk export inquiries, and custom bespoke furniture projects in Jodhpur, India."
  keywords="handicraft wholesale inquiries, export furniture jodhpur, custom furniture manufacturer, b2b furniture supplier india, bulk handicraft orders, furniture factory visit jodhpur"
  url="/contact"
/>

    <div className="cu-page-wrapper">
      <section className="cu-header">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="cu-container">
          <span className="cu-subtitle">Get In Touch</span>
          <h1 className="cu-main-title">Contact Us</h1>
          <p className="cu-header-desc">Monday to Saturday from 9:00 - 18:00</p>
          
        </motion.div>
      </section>

      <section className="cu-content-section">
        <div className="cu-container cu-grid">
          {/* INFO COLUMN */}
            {/* LEFT: INFORMATION BOX */}
          <motion.div 
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="cu-info-column"
          >
            <div className="cu-info-card">
              <div className="cu-info-item">
                <div className="cu-icon-box"><MapPin size={24}/></div>
                <div className="cu-info-text">
                  <h3>Location</h3>
                  <p>P.N. A1 K.N. 135 Ughyog Nagar Tanawara, Jodhpur Raj. India</p>
                </div>
              </div>

              <div className="cu-info-item">
                <div className="cu-icon-box"><Phone size={24}/></div>
                <div className="cu-info-text">
                  <h3>Phone</h3>
                  <p><strong>Jagdish Rao :</strong> +91 9251447224</p>
                  <p>+91 8955646892</p>
                </div>
              </div>

              <div className="cu-info-item">
                <div className="cu-icon-box"><Mail size={24}/></div>
                <div className="cu-info-text">
                  <h3>Email</h3>
                  <p>sohanihandicrafts@gmail.com</p>
                </div>
              </div>

              <div className="cu-info-item">
                <div className="cu-icon-box"><Clock size={24}/></div>
                <div className="cu-info-text">
                  <h3>Hours</h3>
                  <p>Mon - Sat: 9:00 - 18:00</p>
                  <p>Sunday: Closed</p>
                </div>
              </div>
            </div>

            <div className="cu-social-box">
                <h4>Follow our craft</h4>
                <div className="cu-social-links">
                    <a href="#"><Instagram size={20}/></a>
                    <a href="#"><Facebook size={20}/></a>
                    <a href="#"><Linkedin size={20}/></a>
                </div>
            </div>
          </motion.div>

          {/* FORM COLUMN */}
          <div className="cu-form-column">
            <div className="cu-form-wrapper">
              <h2 className="cu-form-title">Send a message</h2>
              <form className="cu-form" onSubmit={handleSubmit}>
                <div className="cu-input-group">
                  <input type="text" name="name" placeholder="Enter Your Name" value={formData.name} onChange={handleChange} required />
                </div>
                <div className="cu-input-group">
                  <input type="email" name="email" placeholder="Enter Your Email" value={formData.email} onChange={handleChange} required />
                </div>
                <div className="cu-input-group">
                  <input type="tel" name="phone" placeholder="Enter Your Phone" value={formData.phone} onChange={handleChange} required />
                </div>
                <div className="cu-input-group">
                  <textarea name="message" placeholder="Message..." rows="4" value={formData.message} onChange={handleChange} required></textarea>
                </div>
                <button type="submit" className="cu-submit-btn" disabled={loading}>
                  {loading ? "Sending..." : "Submit"} <span><Send size={18}/></span>
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
     {/* 3. MAP SECTION */}
      <section className="cu-map-section">
        <div className="cu-container">
            <h2 className="cu-map-label">Find us</h2>
            <div className="cu-map-frame">
              <iframe 
                title="Sohani Handicrafts Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3579.544778107567!2d73.003!3d26.23!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjbCsDEzJzQ4LjAiTiA3M8KwMDAnMTAuOCJF!5e0!3m2!1sen!2sin!4v1620000000000!5m2!1sen!2sin" 
                width="100%" 
                height="500" 
                style={{ border: 0 }} 
                allowFullScreen="" 
                loading="lazy"
              ></iframe>
            </div>
        </div>
      </section>
    </div>
    </>
  );
};

export default ContactPage;